export const actions = {
    updateBankOrder({ commit, getters, state, rootState }, payload) {
        if (payload) {
            commit("setSort", payload);
        }
        const banks = getters.banks;
        const field = state.sortField;
        const direction = state.sortDirection;
        const topBankData = rootState.calculator?.topBank;
        const topBankIdMarketplace = topBankData?.bankId;
        let topBank;
        const otherBanks = [];
        banks.forEach((bank) => {
            if (topBankIdMarketplace &&
                bank.idFM === topBankIdMarketplace) {
                topBank = bank;
            }
            else {
                otherBanks.push(bank);
            }
        });
        otherBanks.sort((a, b) => {
            const valA = a[field];
            const valB = b[field];
            if (valA < valB)
                return direction === "asc" ? -1 : 1;
            if (valA > valB)
                return direction === "asc" ? 1 : -1;
            return 0;
        });
        const sortedBanks = topBank ? [topBank, ...otherBanks] : otherBanks;
        const orderedIds = sortedBanks.map((b) => b.id);
        commit("setOrder", orderedIds);
    },
};
